import { useEffect } from "react";
import { useApp } from "../contexts/AppContext";

export function useActivity() {
  const { resetActivity, setScreensaverActive } = useApp();

  useEffect(() => {
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    const handleActivity = () => {
      resetActivity();
      setScreensaverActive(false);
    };

    // Add event listeners
    events.forEach((event) => {
      document.addEventListener(event, handleActivity, true);
    });

    // Cleanup
    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, handleActivity, true);
      });
    };
  }, [resetActivity, setScreensaverActive]);
}
